import { createContext } from "react";

const MarkdownImageContext = createContext(false);

export default MarkdownImageContext;
